
import type { WeaponClass } from '@cs-shot/battle-sim';
import { SetRushMidWeaponSkinRequestWeaponKeyEnum } from '../../../../services/generated/Api';
import type { RushMidWeaponSkinOption } from '../../../../services/generated/Api';

export type { RushMidWeaponSkinOption };

export type WeaponKey = SetRushMidWeaponSkinRequestWeaponKeyEnum;

export interface RailEntry {
  weapon: WeaponClass;
  weaponKey: WeaponKey;
  skin: RushMidWeaponSkinOption | null;
  title: string;
  classLabel: string;
}

export const WEAPON_CLASSES: { weapon: WeaponClass; label: string }[] = [
  { weapon: 'rifle', label: 'Автомат' },
  { weapon: 'awp', label: 'Снайперская' },
  { weapon: 'lmg', label: 'Пулемёт' },
];

const NON_RIFLE_KEY: Record<Exclude<WeaponClass, 'rifle'>, WeaponKey> = {
  awp: SetRushMidWeaponSkinRequestWeaponKeyEnum.Awp,
  lmg: SetRushMidWeaponSkinRequestWeaponKeyEnum.Lmg,
};

export const keyOf = (side: 't' | 'ct', weapon: WeaponClass): WeaponKey =>
  weapon === 'rifle'
    ? side === 'ct'
      ? SetRushMidWeaponSkinRequestWeaponKeyEnum.M4
      : SetRushMidWeaponSkinRequestWeaponKeyEnum.Ak
    : NON_RIFLE_KEY[weapon];

export function railFor(side: 't' | 'ct', catalog: RushMidWeaponSkinOption[]): RailEntry[] {
  return WEAPON_CLASSES.flatMap(({ weapon, label }) => {
    const weaponKey = keyOf(side, weapon);
    const stock: RailEntry = { weapon, weaponKey, skin: null, title: 'Сток', classLabel: label };
    const skins = catalog
      .filter((s) => s.weaponKey === weaponKey)
      .map((s) => ({ weapon, weaponKey, skin: s, title: s.title, classLabel: label }));
    return [stock, ...skins];
  });
}

export const isWorn = (entry: RailEntry, selection: Record<string, string>): boolean =>
  entry.skin ? selection[entry.weaponKey] === entry.skin.name : !selection[entry.weaponKey];

export function wornFor(rail: RailEntry[], selection: Record<string, string>, weapon: WeaponClass): RailEntry {
  const ofClass = rail.filter((e) => e.weapon === weapon);
  return ofClass.find((e) => isWorn(e, selection)) ?? ofClass[0] ?? rail[0];
}
